import styled from 'styled-components';
import DatePicker from 'react-date-picker';
import FormTypeahead from 'atoms/Inputs/FormTypeahead';

export const TableWrapper = styled.div.attrs({
  className: 'mt-3'
})`
  border: 1px solid #E0E0E0;
  border-radius: 6px;
  overflow-x: auto;

  .react-bootstrap-table {
    display: block;
    overflow-x: auto;
    width: 100%;

    table {
      table-layout: auto;
    }
  }
`
export const PageWrapper = styled.div.attrs(({ isMobile }) => ({
  className: 'p-4'
}))``


export const FilterRow = styled.div.attrs({
  className: 'col-12 mt-3 pb-3 px-0'
})`
  display: flex;
  flex-direction: row;
  align-items: flex-end;

  @media (max-width: 1424px) {
    flex-wrap: wrap;
    padding-top: 0 !important;
  }
`

export const RoundedWrapper = styled.div.attrs({
  className: 'col-12 mt-3'
})`
  flex: 1;
  border: 1px solid #E0E0E0;
  border-radius: 6px;
  margin-right: ${({ gap }) => gap || 0};
`


export const FilterCol = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-right: 20px;

  @media (max-width: 1024px) {
    margin-right: 5px;
  }

  @media (max-width: 768px) {
    margin-right: 10px;
    margin-top: 10px;
  }
`

export const StyledDatePicker = styled(DatePicker)`
  .react-date-picker__wrapper {
    border-radius: 6px !important;
    font-size: 14px !important;
    height: 34px !important;
    border: 1px solid ${({ theme }) => theme.mocaGrey};
  }
  .react-date-picker__inputGroup {
    padding-left: 12px;
  }
`

export const MainWrapper = styled.div`
  padding: 12px;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-start;
`

export const HeadContainer = styled.div`
  padding: 16px 0px;
  display: flex;
  flex-direction: row;
  align-content: center;
  border-bottom: 1px solid #E0E0E0;
`
export const LevelRowContainer = styled.div.attrs({
  className: `row col-12 mx-0`
})`
  padding: 7px 0;
  margin-top: ${({ isTop }) => isTop ? '14px' : 0};
`
export const InputCol = styled.div`
  flex: ${({ flex }) => flex || 1};
  display: flex;
  flex-direction: column;
  margin-right: 5px;
  margin-left: 5px;
`
export const InputRow = styled.div`
  flex: ${({ flex }) => flex || 1};
  display: flex;
  flex-direction: row;
`

export const Footer = styled.div`
  flex: ${({ flex }) => flex || 1};
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-top: 20px;
`

export const Typeahead = styled(FormTypeahead)`
  .rbt-input-main {
    border-color: ${({ theme }) => theme.mocaGrey};
    border-radius: 6px;
    font-size: 14px;
    height: 34px;
    padding: 9px 12px;
  }

  .rbt-input-hint input {
    box-sizing: border-box !important;
    height: 34px;
  }
`

export const ButtonAdd = styled.img`
  height: 40px;
  width: 40px;
  margin-bottom: 20px;

  &:hover {
    opacity: 0.7;
    cursor: pointer;
  };
`

export const File = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 10px;
`

export const IframeWrapper = styled.div.attrs({
  className: 'mb-3'
})`
  max-height: calc(100vh - 300px);
  scroll-behavior: smooth;
  width: 100%;

  @media (max-width: 768px) {
    max-height: calc(100vh - 384px);
  }
`
